module.exports = __webpack_public_path__ + "static/media/0_2018_12_10.3bf3ab5c.jpg";